import * as React from 'react'
import { Link } from 'react-router-dom';
import { connect } from "react-redux";

import {logout} from "./../../redux/actions/auth";
import './../../styles/shared/navbar.css'
import logo from './../../images/logo.png'

class Navbar extends React.Component {

  logout = () => {
    this.props.logout()
    this.props.history.push('/')
  }

  home = () => {
    this.props.history.push('/visits')
  }

  admin = () => {
    this.props.history.push('/admin/locations')
  }

  verification = () => {
    this.props.history.push('/verification')
  }

  render () {
    return (
      <div className='navbar'>
        <div className='navbar-content'>
          <div className='navbar-logo'>
            <Link to="/visits">
              <img src={logo} alt='BayWatch Technologies'/>
            </Link>
          </div>
          <div className='navbar-link-container'>
            <div className='navbar-link' onClick={this.home}>HOME</div>
            {this.props.auth.user.is_superuser &&
              <div className='navbar-link' onClick={this.verification}>VERIFICATION</div>
            }
            {this.props.auth.user.is_superuser &&
              <div className='navbar-link' onClick={this.admin}>ADMIN</div>
            }
            <div className='navbar-link' onClick={this.logout}>LOGOUT</div>
          </div>
        </div>
        <div className="navbar-bottom"></div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return state
}

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(logout()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/components/shared/navbar.js